import { Link } from 'react-router-dom';
import '../styles/auth.css'
import AuthForm from "../components/AuthForm";

const Register = () => {

  return (
    <main className="auth-container">
      <h2>Welcome to Artieve</h2>
      
      <AuthForm type="signUp" />

      <p>Already have an account? <Link to="/login">Log in</Link></p>
    </main>
  );
};

export default Register;